import $http from '../../../axios-instance';
import Swal from 'sweetalert2';
import {dispatch} from 'rxjs/internal/observable/pairs';


/**
 * Método para descargar el inventario de productos químicos.
 *
 * @param {*} param0
 * @param {*} id id del agendamiento
 */
export async function descargarInventario({commit, state}, id) {
    await $http.post(`empresas/procesamientos_background/INVENTARIO-PRODUCTOS/${id}`)
        .then((response) => {
            commit('setInventario', response.data);
            state.error = false;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = true;
        });
}

export async function eliminarReporteAgendado({commit, state}, data) {
    await $http.delete(`empresas/procesamientos_background/INVENTARIO-PRODUCTOS/${data.id_empresa}/${data.id}`)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br >' + error.errors,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

export async function eliminarTodosReportesAgendados({commit}) {
    commit('dashboard/load', true, {root: true});

    await $http.delete(`empresas/procesamientos_background/INVENTARIO-PRODUCTOS`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br >' + error.errors,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Método para agendar la descarga del inventario de productos químicos.
 *
 * @param {*} param0
 * @param {*} tipo contiene el tipo de inventario a descargar,
 */
export async function agendarInventario({commit, state}, tipo) {
    state.selectedInventario.tipo = tipo;
    await $http.post('empresas/procesamientos_background/INVENTARIO-PRODUCTOS', state.selectedInventario)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'El reporte ha sido agendado para su procesamiento en segundo plano',
                text: response.data.message,
                showConfirmButton: false,
                timer: 6000
            });
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br >' + error.errors,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Metodo para visualizar los inventarios agendados del usuario
 *
 * @export
 * @param {*} { commit, state}
 */
export async function listarInventariosAgendados({commit, state}) {
    await $http.get('empresas/procesamientos_background/INVENTARIO-PRODUCTOS')
        .then((response) => {
            commit('setInventariosProcesados', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Método que lista las empresas registradas en el sistema.
 *
 * @param {*} param0
 */
export async function listarEmpresas({state, commit}) {

    await $http.get('/empresas')
        .then((response) => {

            commit('cargarEmpresas', response.data.data.data);
        })
        .catch((error) => {

        });
}

/**
 * Método para obtener las empresas utilizando autocompletado.
 *
 * @export
 * @param {*} { commit, rootState }
 * @param {*} nombre
 */
export async function getEmpresas({commit, rootState, dispatch}, nombre) {

    if (!rootState.dashboard.cargando_datos_select) {
        commit('dashboard/setCargandoDatos', true, {root: true});
        await $http.get('/empresas/lista', {params: nombre})
            .then(async (response) => {
                commit('setEmpresas', response.data.data);
                commit('dashboard/setCargandoDatos', false, {root: true});
            })
            .catch((error) => {
                commit('mensajeError', error.message);
                commit('dashboard/setCargandoDatos', false, {root: true});
            });
    }
}

/**
 * Método para obtener las bases de una empresa en especifico.
 *
 * @param {*} param0
 */
export async function getBases({commit, state}) {

    var empresa = state.selectedInventario.empresa;

    if ((empresa === null) || (empresa === '')) {
        empresa = 0;
    }

    await $http.get(`empresas/bases/${empresa}`)
        .then((response) => {

            commit('cargarBases', response.data.data);
        })
        .catch((error) => {
            //commit('mensajeError', error.message)
        });
}

/**
 * Método para obtener las áreas de una empresa en especifico.
 *
 * @param {*} param0
 */
export async function getAreas({commit, state}) {

    var empresa = state.selectedInventario.empresa;

    if ((empresa === null) || (empresa === '')) {
        empresa = 0;
    }

    await $http.get(`empresas/areas/${empresa}`)
        .then((response) => {
            ;
            commit('cargarAreas', response.data.data);
        })
        .catch((error) => {

        });
}

/**
 * listar las empresas
 * @param {*} param0
 */
export async function listarUbicacionesEmpresa({dispatch, state, rootState, commit}, id) {
    if(id){
        await dispatch('location/arbolUbicacionesEmpresa', id, {root: true});
    }
    commit('setUbicacioneEmpresa', rootState.location.arbolUbicaciones);
}

export async function listarContratistas({state, commit}) {
    let requestParameters = {
        params: {
            id_empresa: state.selectedInventario.empresa,
            solo_asignados: true
        }
    };

    commit('dashboard/load', true, {root: true});
    await $http.get('/contratistas', requestParameters)
        .then((response) => {
            commit('setContratistas', response.data.data);
        });
    commit('dashboard/load', false, {root: true});
}


/**
 * Optener emporesa por id
 * @param {*} id
 */
export async function getEmpresa({commit}, id) {
    await $http.get(`/companies/show/${id}`)
        .then((response) => {
            commit('setEmpresa', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        });
}




/**
 * Agendar reporte de inventario
 * @param payload
 * @autor Paul Valencia
 */
export async function scheduleInventoryReport({commit}, payload) {
    try {
        const response = await $http.post(`empresas/procesamientos_background/REPORTE-INVENTARIO`, payload);
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 6000
        });
    } catch (error) {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.errors,
            showConfirmButton: true,
            timer: 5000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Cargar procesos en segundo plano.
 * @param company_id
 * @returns {Promise<void>}
 */
export async function loadProccessBackground({ commit, state },company_id) {
    try {
        commit('dashboard/load', true, {root: true});
        const response =await $http.get(`empresas/procesamientos_background/REPORTE-INVENTARIO/${company_id}`);
        commit('setBackgroundProcess', response.data.data);
    } catch (error) {
        return Promise.reject(error.message)
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}



/**
 * Metodo para descargar el archivo generado en segundo plano
 *
 * @export
 * @param id
 */
export async function downloadReport({commit, state}, id) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`empresas/procesamientos_background/REPORTE-INVENTARIO/${id}`);
        return response.data.data
    } catch (error) {
        return Promise.reject(error.message)
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}
